import { service } from '@/utils/request'

export default {
  /**
   * [getMenuList 医生登录日志]
   * @param  {[obj]} data [筛选数据]
   * @return {[obj]}
   */
  logList(data) {
    return service({
      url: '/cloud/uac/admin/userLogin/pages',
      method: 'get',
      params: data
    })
  },
  logDetail(data) {
    return service({
      url: '/cloud/uac/doctor/operateLog/getDoctorLoginLogDetail',
      method: 'get',
      params: data
    })
  },

  // 白名单分页查询
  getWhiteList(params) {
    return service({
      url: '/cloud/uac/admin/userLogin/whiteList/pages',
      method: 'get',
      params
    })
  },

  // 白名单新增
  addWhiteUser(params) {
    return service({
      url: '/cloud/uac/admin/userLogin/whiteList/add',
      method: 'post',
      params
    })
  },

  // 白名单删除
  removeWhiteUser(params) {
    return service({
      url: '/cloud/uac/admin/userLogin/whiteList/delete',
      method: 'post',
      params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/systemManage/docLoginLog.js